<script setup>
  import { ref, onMounted } from "vue";
  import axios from "axios";

  const props = defineProps({
    listMenu: {
      type: String,
      required: true
    }
  });
  const categories = ref({});
  const openSubmenus = ref({});

  const fetchCategories = async (item) => {
    if (!item.categoryHasChilds) {
      return;
    }

    const categoryId = item.categoryId;
    openSubmenus.value[categoryId] = !openSubmenus.value[categoryId];

    if (!categories.value[categoryId] && openSubmenus.value[categoryId]) {
      try {
        const url = `/api/${window.lang}/get-category-api?category_id=${categoryId}`;
        const response = await axios.get(url);
        categories.value[categoryId] = response.data;
      } catch (error) {
        console.error("Ocorreu um erro ao buscar as categorias:", error);
      }
    }
  };

  onMounted(() => {
  });
</script>

<template>
  <div class="menu-lateral">
    <ul class="menu-inicio">
      <li
        class="element-list"
        v-for="item in listMenu.menu_mobile"
        :key="item.link"
        :class="{ 'submenu-open': openSubmenus[item.categoryId] }">
        <a
          :class="{
            'store-travocar': item.class?.includes('store-travocar'),
            'item-uppercase': item.class?.includes('item-uppercase'),
            'item-bold': item.class?.includes('item-bold'),
            'item-border': item.class?.includes('item-border'),}"
          :href="item.categoryHasChilds ? '#' : item.link"
          @click="fetchCategories(item)">
          {{ item.label }}
          <button
            v-if="item.categoryHasChilds === true"
            :class="{ 'rotate-svg': openSubmenus[item.categoryId] }">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="7"
              height="12"
              viewBox="0 0 7 12"
              fill="none">
              <path
                d="M1 10.9984L6 6.00195L1 1.00195"
                stroke="black"
                stroke-miterlimit="10" />
            </svg>
          </button>
        </a>
        <div v-if="openSubmenus[item.categoryId]" class="submenu">
          <a :href="category.link"
             v-for="category in categories[item.categoryId]"
             :key="category.link">
            {{ category.label }}
          </a>
        </div>
      </li>
    </ul>
  </div>
</template>

<style scoped>

  .element-list {
    height: auto;
    position: relative;
    & > a {
      font-size: 13px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      text-decoration: none;
      color: black;
      padding: 0 20px 0 20px;
      height: 50px;
      button{
        background: none;
        border: none;
        cursor: pointer;
        padding: 0;
        margin-left: 10px;
        transition: transform 0.3s ease-in-out;
      }
    }
  }

  .submenu {
    padding-left: 10px;
    height: 0;
    overflow: hidden;
    a{
      display: block;
      padding: 8px 0 8px 10px;
      text-decoration: none;
      color: #333;
      font-size: 12px;
      text-transform: uppercase;
      font-family: "Montserrat", serif;
      transition: all 0.3s;
      &:hover{
        font-weight: 700;
      }
    }
  }
  .submenu-open .submenu {
    height: auto;
  }


  .rotate-svg {
    transform: rotate(90deg);
  }
</style>
